import type { ReactElement } from "react";
import { Route } from "react-router";
import { HomePage } from "../pages/HomePage";
import { NetworkPage } from "../pages/NetworkPage";
import { PricingPage } from "../pages/PricingPage";
import { DocsAuthenticationPage } from "../pages/docs/DocsAuthenticationPage";
import { DocsCoreConceptsPage } from "../pages/docs/DocsCoreConceptsPage";
import { DocsEventsPage } from "../pages/docs/DocsEventsPage";
import { DocsInferenceNetworkPage } from "../pages/docs/DocsInferenceNetworkPage";
import { DocsIntroductionPage } from "../pages/docs/DocsIntroductionPage";
import { DocsLayout } from "../pages/docs/DocsLayout";
import { DocsPersistentStatePage } from "../pages/docs/DocsPersistentStatePage";
import { DocsQuickstartPage } from "../pages/docs/DocsQuickstartPage";
import { DocsSdkPage } from "../pages/docs/DocsSdkPage";
import { DocsSelfHostingPage } from "../pages/docs/DocsSelfHostingPage";
import { DocsSessionsPage } from "../pages/docs/DocsSessionsPage";
import { DocsSpatialPage } from "../pages/docs/DocsSpatialPage";
import { DocsWovenHostPage } from "../pages/docs/DocsWovenHostPage";
import { DOCS_SECTIONS, docsPath } from "../pages/docs/docsNav";

export const DOCS_ROUTE_ELEMENTS: Record<string, ReactElement> = {
  quickstart: <DocsQuickstartPage />,
  "core-concepts": <DocsCoreConceptsPage />,
  sessions: <DocsSessionsPage />,
  events: <DocsEventsPage />,
  "spatial-subspaces": <DocsSpatialPage />,
  "persistent-state": <DocsPersistentStatePage />,
  "inference-network": <DocsInferenceNetworkPage />,
  authentication: <DocsAuthenticationPage />,
  "sdks/rust": <DocsSdkPage slug="sdks/rust" />,
  "sdks/javascript": <DocsSdkPage slug="sdks/javascript" />,
  "deploy/self-hosting": <DocsSelfHostingPage />,
  "deploy/woven-host": <DocsWovenHostPage />,
};

function docsRouteElement(slug: string): ReactElement {
  const element = DOCS_ROUTE_ELEMENTS[slug];
  if (!element) {
    throw new Error(`Missing docs route content for: ${slug}`);
  }
  return element;
}

export const PUBLIC_ROUTE_PATHS = [
  "/",
  "/pricing",
  "/network",
  ...DOCS_SECTIONS.flatMap((section) => section.items.map((item) => docsPath(item.slug))),
];

export const PUBLIC_ROUTE_ELEMENTS = (
  <>
    <Route index element={<HomePage />} />
    <Route path="docs" element={<DocsLayout />}>
      <Route index element={<DocsIntroductionPage />} />
      {DOCS_SECTIONS.flatMap((section) =>
        section.items
          .filter((item) => item.slug !== "")
          .map((item) => (
            <Route key={item.slug} path={item.slug} element={docsRouteElement(item.slug)} />
          ))
      )}
    </Route>
    <Route path="pricing" element={<PricingPage />} />
    <Route path="network" element={<NetworkPage />} />
  </>
);
